import { render } from "./AdvantageSection.vue?vue&type=template&id=601b316e&scoped=true"
import script from "./AdvantageSection.vue?vue&type=script&lang=js"
export * from "./AdvantageSection.vue?vue&type=script&lang=js"

import "./AdvantageSection.vue?vue&type=style&index=0&id=601b316e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601b316e"]])

export default __exports__